export default __webpack_public_path__ + "static/media/CREOS_DORIAN_120X278_02_265.956c1790.jpg";